import {BaseMobxStore} from "../../../../infrastructure/mobx/base-mobx-store";
import {AthleteNextGameModuleConfig} from "./athlete-next-game.module.config";
import {AthleteNextGameModuleState} from "./models/athlete-next-game.module.state";

export class AthleteNextGameModuleStore extends BaseMobxStore {
  static injectables = [AthleteNextGameModuleConfig, AthleteNextGameModuleState];
}
